package `fun`.adaptive.resource.string

object Strings